import { AgeGroupsView } from "../view/age_groups_view";
import { AgeGroupData } from "../model/age_group_series";
import $ from "jquery";

class AgeGroupsController {
  private view: AgeGroupsView;
  private container: JQuery<HTMLElement>;

  constructor(container: JQuery<HTMLElement>) {
    this.container = container;
    this.view = new AgeGroupsView(container);
  }

  /**
   * 世代別データを取得してグラフを描画
   */
  render(keyword: string, combinationKeyword?: string): JQuery.Promise<any> {
    const dfd = $.Deferred<any>();

    // ローディング表示
    this.view.showLoading();

    // エンドポイントURLを構築
    const url = "/additional_researches/age_groups";
    const params: any = {
      keyword: keyword,
    };

    if (combinationKeyword) {
      params.combination_keyword = combinationKeyword;
    }

    // データを取得
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: params,
    })
      .done((data: AgeGroupData) => {
        // グラフを描画
        this.view.render(data, keyword, combinationKeyword);
        dfd.resolve(data);
      })
      .fail((xhr: any) => {
        // エラー表示
        let errorMessage = "エラーが発生しました。";
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = xhr.responseJSON.error;
        } else if (xhr.status === 0) {
          errorMessage = "ネットワークエラーが発生しました。";
        } else if (xhr.status >= 500) {
          errorMessage = "サーバーエラーが発生しました。";
        }
        this.view.showError(errorMessage);
        dfd.reject(xhr);
      });

    return dfd.promise();
  }
}

export { AgeGroupsController };

